/* Compagnons de Cœur — sac cadeau réutilisable (mission 2026-10-06-13). Chargé par snippets/cdc-sac-cadeau.liquid, seulement quand le sac
 * est en vente (window.CDCGiftBag).
 * - Panier (tiroir et page) : la case [data-cdc-sac-toggle] ajoute UN sac (s'il n'y en a pas) ou retire toutes les lignes du sac, puis le
 *   thème redessine le tiroir et la page (theme.Cart.updateCart), qui relisent l'état réel du panier.
 * - Fiches non personnalisées : la case [data-cdc-sac-produit-case] ajoute un sac après l'ajout de l'article (événement du thème
 *   « theme:cart::added »), jamais un deuxième.
 * - Un panier qui ne contient plus que le sac le perd (retrait de l'article) : le sac n'est pas vendu seul.
 * Les commandes Atelier passent par assets/cdc-atelier-cart.js (même produit, même règle d'un seul sac). */
(function () {
  'use strict';
  var bag = window.CDCGiftBag;
  if (!bag || !/^\d{1,20}$/.test(String(bag.variantId))) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(/\/$/, '');
  var busy = false;

  function post(path, body) {
    return fetch(root + '/cart/' + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body) });
  }
  function cart() { return fetch(root + '/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function isBag(item) { return String(item.variant_id) === String(bag.variantId) || (bag.productId && String(item.product_id) === String(bag.productId)); }
  function bagLines(data) { return data.items.filter(isBag); }
  function redraw() {
    var c = window.theme && window.theme.Cart;
    if (c && c.updateData && c.updateCart) return c.updateData().then(function () { return c.updateCart(); });
    if (/\/cart\/?$/.test(location.pathname)) location.reload();
    return Promise.resolve();
  }
  async function addOne() {
    var data = await cart();
    if (bagLines(data).length) return false;
    var response = await post('add.js', { items: [{ id: Number(bag.variantId), quantity: 1 }] });
    return response.ok;
  }
  // Pour les fiches à motifs (assets/cdc-fiche-motif.js), qui ajoutent l'article elles-mêmes puis ouvrent le tiroir.
  bag.addOne = addOne;
  async function removeAll() {
    var lines = bagLines(await cart());
    for (var i = 0; i < lines.length; i++) await post('change.js', { id: lines[i].key, quantity: 0 });
  }

  // Panier : cocher ajoute, décocher retire.
  document.addEventListener('change', function (event) {
    var box = event.target && event.target.closest && event.target.closest('[data-cdc-sac-toggle]');
    if (!box || busy) return;
    var label = box.closest('[data-cdc-sac]');
    busy = true; box.disabled = true; if (label) label.setAttribute('aria-busy', 'true');
    (box.checked ? addOne() : removeAll()).catch(function (error) { console.warn('[cdc-sac-cadeau]', error); })
      .then(redraw).finally(function () { busy = false; box.disabled = false; if (label) label.removeAttribute('aria-busy'); });
  });

  // Fiches : l'article est ajouté par le thème ; le sac suit, si la case de cette fiche est cochée.
  document.addEventListener('theme:cart::added', function (event) {
    var product = event.detail && event.detail.product;
    var box = product && product.querySelector && product.querySelector('[data-cdc-sac-produit-case]');
    if (!box || !box.checked) return;
    box.checked = false;
    addOne().then(function (added) { if (added) return redraw(); }).catch(function (error) { console.warn('[cdc-sac-cadeau]', error); });
  });

  // Le sac n'est pas vendu seul : retiré quand il ne reste que lui.
  function pruneAlone() {
    return cart().then(function (data) {
      if (data.items.length && data.items.every(isBag)) return removeAll().then(redraw);
    }).catch(function () { /* le panier affiche alors la phrase « Le sac cadeau accompagne une commande » */ });
  }
  document.addEventListener('theme:cart::removed', function () { setTimeout(pruneAlone, 1500); });
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('.js-input-quantity-cart')) setTimeout(pruneAlone, 2500);
  });
  if (/\/cart\/?$/.test(location.pathname)) pruneAlone();
})();
